module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_ecuador-2dce4f75.png";